import {
  makeStyles,
  Skeleton,
  SkeletonItem,
  tokens,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { Breakpoints } from "../../style/styles";

const useClasses = makeStyles({
  root: {
    ...Breakpoints.extraExtraLarge({
      width: "calc(100vw - 40px)",
      marginLeft: "calc(-50vw + 50%)",
      paddingLeft: "10px",
    }),
  },
  skeletonRow: {
    marginBottom: tokens.spacingVerticalM,
  },
  skeletonHeader: {
    marginBottom: tokens.spacingVerticalM,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  skeletonButton: {
    width: "100px",
  },
  skeletonSearch: {
    width: "300px",
  },
});

export const ChapterListSkeleton = () => {
  const classes = useClasses();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Skeleton aria-label={t("loading")}>
        <div className={classes.skeletonHeader}>
          <SkeletonItem
            className={classes.skeletonButton}
            shape="rectangle"
            size={40}
          />
          <SkeletonItem
            className={classes.skeletonSearch}
            shape="rectangle"
            size={40}
          />
        </div>
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
        <SkeletonItem className={classes.skeletonRow} size={40} />
      </Skeleton>
    </div>
  );
};
